<template>
    <div class="form-table" ref="formTableRef">
        <el-table :data="data" ref="tableRef" border stripe>
            <el-table-column type="index" width="50" fixed="left">
                <template #header>
                    <el-button v-if="!hideAdd" type="primary" icon="el-icon-plus" size="small" circle @click="rowAdd"></el-button>
                </template>
                <template #default="scope">
                    <div :class="['form-table-handle', {'form-table-handle-delete':!hideDelete}]">
                        <span>{{scope.$index + 1}}</span>
                        <el-button v-if="!hideDelete" type="danger" icon="el-icon-delete" size="small" plain circle @click="rowDel(scope.row, scope.$index)"></el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="" width="50" v-if="dragSort">
                <template #default>
                    <div class="move" style="cursor: move;"><el-icon-d-caret style="width: 1em; height: 1em;"/></div>
                </template>
            </el-table-column>
            <el-table-column
                v-for="(tf, ti) in form.config.columns"
                :key="ti"
                :prop="ti"
                :label="tf.label">
                <template #default="scope">
                    <template v-if="tf.form === 'select'">
                        <el-select
                            v-model="scope.row[ti]"
                            clearable
                            filterable
                            default-first-option
                            :reserve-keyword="false"
                            placeholder="请选择"
                            :allow-create="true">
                            <template v-for="(item, index) in tf.options" :key="index">
                                <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                    <el-option
                                        :label="item"
                                        :value="index"
                                        :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                        <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                        <text v-else>{{ item }}</text>
                                    </el-option>
                                </template>
                                <template v-else>
                                    <el-option
                                        :label="item[tf.config.key]"
                                        :value="item[tf.config.value]"
                                        :disabled="item.disabled">
                                        <text v-if="item.title_display" v-html="item.title_display" />
                                        <text v-else>{{ item[tf.config.key] }}</text>
                                    </el-option>
                                </template>
                            </template>
                        </el-select>
                    </template>
                    <template v-if="tf.form === 'text'">
                        <el-input v-model="scope.row[ti]" placeholder="请输入内容"></el-input>
                    </template>
                    <template v-if="tf.form === 'static'">
                        <div>{{scope.row[ti]}}</div>
                    </template>
                    <template v-if="tf.form === 'image'">
                        <template v-if="form.images && form.images.length > 0 && form.images[scope.$index] && form.images[scope.$index].file_path">
                            <el-image style="width: 100px; height: 50px" fit="contain" :src="Utils.getImgUrl(form.images[scope.$index].file_path)" @click="uploadImage(scope.$index, ti)"></el-image>
                        </template>
                        <template v-else>
                            <el-button type="primary" @click="uploadImage(scope.$index, ti)">上传图片</el-button>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <slot></slot>
            <template #empty>
                {{placeholder}}
            </template>
        </el-table>
        <upload ref="uploadRef" v-model="files" v-model:checkedData="filesPath" :is-ueditor="true" dir="images" />
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, watch, nextTick, onMounted } from 'vue'
    import Sortable from 'sortablejs'
    import Upload from '../../ui-upload'
    import Utils from '@/utils/util'

    export default defineComponent({
        components: {
            Upload
        },
        props: {
            modelValue: {
                type: String,
                default: ''
            },
            addTemplate: {
                type: Object,
                default: () => {}
            },
            placeholder: {
                type: String,
                default: '暂无数据'
            },
            dragSort: {
                type: Boolean,
                default: false
            },
            hideAdd: {
                type: Boolean,
                default: false
            },
            hideDelete: {
                type: Boolean,
                default: false
            },
            forms: {
                type: Object,
                default: () => {}
            }
        },
        watch: {
            modelValue() {
                this.data = JSON.parse(this.modelValue)
                if (!this.data || this.data.length <= 0) {
                    this.data = []
                }
            },
            data: {
                handler() {
                    this.$emit('update:modelValue', JSON.stringify(this.data))
                },
                deep: true
            }
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()
            const form = ref(props.forms)
            const formTableRef = ref()
            const tableRef = ref()
            const uploadRef = ref()
            const data = ref()
            const files = ref([])
            const filesPath = ref([])
            const editIndex = ref(0)
            const editField = ref('')

            watch(
                () => files.value,
                (newv, oldv) => {
                    if (newv !== '') {
                        if (form.value.images) form.value.images[editIndex.value].file_path = filesPath.value
                        data.value[editIndex.value][editField.value] = newv
                        filesPath.value = ''
                        files.value = ''
                    }
                }
            )

            const rowDrop = () => {
                const tbody = tableRef.value.$el.querySelector('.el-table__body-wrapper tbody')
                Sortable.create(tbody, {
                    handle: '.move',
                    animation: 300,
                    ghostClass: 'ghost',
                    onEnd({ newIndex, oldIndex }) {
                        let newImages = ''
                        if (form.value.images) {
                            form.value.images.splice(newIndex, 0, form.value.images.splice(oldIndex, 1)[0])
                            newImages = form.value.images.slice(0)
                            form.value.image = []
                        }

                        data.value.splice(newIndex, 0, data.value.splice(oldIndex, 1)[0])
                        const newArray = data.value.slice(0)
                        const tmpHeight = formTableRef.value.offsetHeight
                        formTableRef.value.style.setProperty('height', tmpHeight + 'px')
                        data.value = []
                        nextTick(() => {
                            data.value = newArray
                            if (form.value.images) form.value.images = newImages
                            nextTick(() => {
                                formTableRef.value.style.removeProperty('height')
                            })
                        })
                    }
                })
            }
            const rowAdd = () => {
                const temp = JSON.parse(JSON.stringify(props.addTemplate))
                data.value.push(temp)
                if (form.value.images) {
                    form.value.images.push({
                        type: 'image',
                        file_path: ''
                    })
                }
            }
            const rowDel = (row, index) => {
                data.value.splice(index, 1)
                if (form.value.images) {
                    form.value.images.splice(index, 1)
                }
            }
            const uploadImage = (index, field) => {
                editField.value = field
                editIndex.value = index
                uploadRef.value.upButton()
            }
            onMounted(() => {
                data.value = JSON.parse(props.modelValue)
                if (!data.value || data.value.length <= 0) {
                    data.value = []
                }
                if (props.dragSort) {
                    rowDrop()
                }
            })

            return {
                Utils,
                data,
                form,
                files,
                filesPath,

                rowDrop,
                rowAdd,
                rowDel,
                uploadImage,

                formTableRef,
                tableRef,
                uploadRef
            }
        }
    })
</script>

<style scoped>
    .form-table {width: 100%;}
    .form-table .form-table-handle {text-align: center;}
    .form-table .form-table-handle span {display: inline-block;}
    .form-table .form-table-handle button {display: none;}
    .form-table .hover-row .form-table-handle-delete span {display: none;}
    .form-table .hover-row .form-table-handle-delete button {display: inline-block;}
    .form-table .move {text-align: center;font-size: 14px;margin-top: 3px;}
</style>
